import gameIds from '../../hub/data/GameIds';

export const GAME_ID = gameIds.CODEX;

export const LEVEL_COUNT = 8;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
  ONBOARDING: 'ONBOARDING',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
  SUMMARY: 'SUMMARY',
  PAYOFF: 'PAYOFF',
};

export const QUESTION_TYPES = {
  STANDARD: 'standard',
  ONBOARDING: 'onboarding',
  SELF_CORRECT: 'self_correct',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_ROUND: 'INITIALIZE_ROUND',
  RESUME_ROUND: 'RESUME_ROUND',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  INCREASE_PROGRESS: 'INCREASE_PROGRESS',
  SELECT_RESPONSE: 'SELECT_RESPONSE',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
  SET_QUESTIONS_COUNT: 'SET_QUESTIONS_COUNT',
  SET_CORRECT_QUESTIONS_COUNT: 'SET_CORRECT_QUESTIONS_COUNT',
  REVEAL_HINT: 'REVEAL_HINT',
  SELECT_HINT: 'SELECT_HINT',
  TURN_SCAFFOLDING_MODE_ON: 'TURN_SCAFFOLDING_MODE_ON',
  SET_SUMMARY_QUESTION_ANSWER: 'SET_SUMMARY_QUESTION_ANSWER',
  UPDATE_HIGHEST_LEVEL_EARNED: 'UPDATE_HIGHEST_LEVEL_EARNED',
  REGISTER_CHUNKS_LAYOUT: 'REGISTER_CHUNKS_LAYOUT',
  SAVE_PROGRESS_DATA: 'SAVE_PROGRESS_DATA',
  REMOVE_PROGRESS_DATA: 'REMOVE_PROGRESS_DATA',
  QUICK_ROUND: 'QUICK_ROUND',
  UPDATE_RECORDS: 'UPDATE_RECORDS',
};

export const TAG_TYPES = {
  REGULAR: 0,
  SIMILE: 1,
  METAPHOR: 2,
  PERSONIFICATION: 3,
};

export const TAG_TIPS = {
  [TAG_TYPES.SIMILE]: 'Simile',
  [TAG_TYPES.METAPHOR]: 'Metaphor',
  [TAG_TYPES.PERSONIFICATION]: 'Personification',
};

export const CHUNK_TYPES = {
  FIGURATIVE: 1,
  DISTRACTOR: 2,
  LITERAL: 3,
};

export const SCANNING_TIMEOUT = 2000;

export const ONBOARDING_PHASES = {
  INTRO: 'INTRO',
  MAIN: 'MAIN',
};
